//react
import React from 'react';

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CartProductAdded } from 'redux/actions';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-pro-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";

//components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

//
import Parser from 'html-react-parser';

// @material-ui/icons
import AddShoppingCart from "@material-ui/icons/AddShoppingCart";


function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class ProductDetails extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      product: props.product,
      highlight: false
    };

    this.state.product.qty = 1;

    this.addToCart = this.addToCart.bind(this);
    this.revertColor = this.revertColor.bind(this);
  }

  handleClickOpen(modal) {
    var x = [];
    x[modal] = true;
    this.setState(x);
  }

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  addToCart() {
    setTimeout(this.revertColor,2300);
    this.setState({highlight:true});

    console.log(this.state.product)

    var product = {
     id: this.state.product.id,
     description: this.state.product.description,
     listPrice: this.state.product.listPrice,
     name: this.state.product.name,
     photo: this.state.product.photo,
     qty: this.state.product.qty,
     sku: this.state.product.sku,
     thumbnail: this.state.product.thumbnail
    }
    this.props.onCartProductAdded(product);
    this.updateQty(1);

    this.handleClose("modal");
  }

  revertColor() {
    this.setState({highlight:false});
    clearTimeout(this.revertColor);
  }

  updateQty(qty) {
    var product = this.state.product;
    product.qty = qty;
    this.setState({product: product});
  }

  showQty() {
    if(this.state.product.qty > 0) {
      return "block";
    } else {
      return "none";
    }
  }

  showSize() {
    if(this.state.product.size) {
      return "table-row";
    } else {
      return "none";
    }
  }

  showAttachments() {
    if(this.props.product.attachments) {
      return "block";
    } else {
      return "none";
    }
  }

  showHtmlContentTab() {
    if(this.state.product.Content)
      return false;
    else 
      return true;
  }
  htmlContent() {
    if(this.state.product.Content)
      return Parser(this.state.product.Content);
    else 
      return "";
  }

  trim(value, maxLength) {
    if(value) {
        if(value.trim().length > maxLength)
            return value.trim().substring(0,maxLength) + "...";
        else
            return value.trim();
    } else return "";
  }

  cartOpacity() {
    if(this.state.highlight) {
      return 0.5;
    } else {
      return 1.0;
    }
  }

  openAttachment(attachment) {
    window.open(attachment.URL,attachment.Name,"resizable=1,location=0,toolbar=0,height=600,width=400,left=200,top=100");
  }

  render() {

    const { classes } = this.props;

    return (
        
        <GridItem md={4} sm={4} >
          <Card>
            <CardBody style={{cursor: "pointer"}} onClick={() => this.handleClickOpen("modal")}>
              <div style={{textAlign:"center"}}>
                <img src={this.props.product.thumbnail} alt=".." style={{minHeight:"127px", maxHeight:"127px", maxWidth:"95%" }} />
              </div>
              <hr />
              <div style={{minHeight:"170px"}}>
                <h4 style={{fontFamily:'"Roboto Slab", "Times New Roman", serif', fontSize:"15px"}}>{this.trim(this.props.product.name,40)}</h4>
                <p style={{color:"#3fa31b"}}>
                  <span style={{color:"#232323", fontSize:"11px", marginLeft:"10px"}}>{this.props.product.productID}</span>
                </p>
                <div className={classes.description} style={{minHeight:"67px"}}>
                  {this.props.product.description}
                </div>
              </div>
            </CardBody>
            <CardFooter>
              <div className={classes.priceContainer}>
                <span className={classes.price} style={{fontWeight:400}} > ${this.props.product.listPrice}</span>
              </div>
              <div style={{display:"inline-block", textAlign:"right", width:"100%", height:"34px" }}>
                <div style={{display:"inline-block", height:"34px", position:"relative", top:"-6px"}}>
                  <input type="text" value={this.state.product.qty} onChange={(e) => this.updateQty(e.target.value)} placeholder="qty" style={{height:"34px",borderStyle:"none", backgroundColor:"#efefef", padding:"6px", paddingRight:"10px", borderTopLeftRadius:"6px", borderBottomLeftRadius:"6px", textAlign:"right", width:"50px" }} />
                </div>
                <div onClick={() => this.addToCart()} style={{height:"34px", backgroundColor:"#DF8F43", opacity:this.cartOpacity(), transition:"opacity 0.5s", padding:"4px", borderTopRightRadius:"6px", borderBottomRightRadius:"6px", display:"inline-block", cursor:"pointer", width:"43px", textAlign:"center"}} >
                  <AddShoppingCart style={{color:"white", height:"17px", marginTop:"6px"}} /> 
                </div>
              </div>
            </CardFooter>
          </Card>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description"
            >

            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >

              <GridContainer direction="row">
                <GridItem xs={12} sm={12}>
                  <h4 className={classes.modalTitle}>Details</h4>
                </GridItem>
              </GridContainer>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>

              <CustomTabs
                headerColor="warning"
                tabs={[
                  {
                    tabName: "General",
                    tabContent: (
                      
                      <GridContainer direction="row" style={{minHeight:"369px"}}>
                        <GridItem xs={12} sm={6}>
                          <img src={this.props.product.photo} style={{width:"100%"}} alt="product" />

                          <Table style={{marginTop:"23px", display:this.showAttachments()}}>
                            <TableBody>
                            {this.props.product.attachments.map((attachment,index) => ( 
                                <TableRow key={index} >
                                  <TableCell style={{padding:"3px", color:"#DF8F43", width:"100%", cursor:"pointer"}} onClick={() => this.openAttachment(attachment)}>{attachment.Name}</TableCell>
                              </TableRow>
                            ))}
                            </TableBody>
                          </Table>
                        </GridItem>
                        <GridItem xs={12} sm={6}>
                          <h5>{this.props.product.name}</h5>
                          <p>{this.props.product.description}</p>

                          <Table style={{marginTop:"23px"}}>
                            <TableBody>
                              <TableRow>
                                  <TableCell style={{padding:"3px"}}>Price</TableCell>
                                  <TableCell style={{padding:"3px", color:"#DF8F43"}}>${this.props.product.listPrice}</TableCell>
                              </TableRow>
                              <TableRow style={{display:this.showSize()}}>
                                  <TableCell style={{padding:"3px"}}>Size</TableCell>
                                  <TableCell style={{padding:"3px"}}>{this.props.product.size}</TableCell>
                              </TableRow>
                              <TableRow>
                                  <TableCell style={{padding:"3px"}}>SKU</TableCell>
                                  <TableCell style={{padding:"3px"}}>{this.props.product.sku}</TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                          <p></p>
                        </GridItem>
                      </GridContainer>
                    )
                  }, 
                  {
                    tabName: "More",
                    tabHidden: this.showHtmlContentTab(),
                    tabContent: (
                      <GridContainer style={{minHeight:"369px", maxHeight:"469px", overflowY: "scroll"}}>
                        {this.htmlContent()}
                      </GridContainer>
                    )
                  }
                ]} />
              
            </DialogContent>
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef", marginTop:"-17px"}}>
                <Button
                  onClick={() => this.handleClose("modal")}
                  style={{float: "right"}}
                >
                  Cancel
                </Button>
                &nbsp;
                <div style={{display:"inline-block", textAlign:"right", width:"123px", height:"43px", marginRight:"4px" }}>
                  <div style={{display:"inline-block", height:"43px", position:"relative", top:"-4px"}}>
                    <input type="text" value={this.state.product.qty} onChange={(e) => this.updateQty(e.target.value)} placeholder="qty" style={{height:"43px",borderStyle:"none", backgroundColor:"#ffffff", color:"green", padding:"6px", paddingRight:"12px", borderTopLeftRadius:"6px", borderBottomLeftRadius:"6px", textAlign:"right", width:"50px" }} />
                  </div>
                  <div onClick={() => this.addToCart()} style={{height:"43px", backgroundColor:"#DF8F43", opacity:this.cartOpacity(), transition:"opacity 0.5s", padding:"4px", borderTopRightRadius:"6px", borderBottomRightRadius:"6px", display:"inline-block", cursor:"pointer", width:"69px", textAlign:"center"}} >
                    <AddShoppingCart style={{color:"white", height:"17px", marginTop:"9px"}} /> 
                  </div>
                </div>
                  
            </DialogActions>
          </Dialog>
        </GridItem>     
    );
  }
}

const mapStateToProps = state => {
  return state;
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({onCartProductAdded: CartProductAdded }, dispatch);  
}

ProductDetails = connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
export default withStyles(modalStyle)(ProductDetails);


// WEBPACK FOOTER //
// ./src/components/ProductDetails/ProductDetails.jsx